export default "__VITE_ASSET__B7pm2goi__"